// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__1usc4","footer":"ModalFilter_footer___SZNg"};